import React from "react";
import "../styles/Home.css";
import { useNavigate } from "react-router-dom";

export function AndroidAppPopup() {
    const navigate = useNavigate();
    const redirectPath = new URLSearchParams(window.location.search).get("redirectPath");
    const openDSEmobileApp = () => {
        window.location.href = "dse://open";
    }
    const downloadApp = () => {
        window.location.href = "https://play.google.com/store/apps/details?id=com.devansh.stockmarket";
    }
    const continueOnWeb = () => {
        localStorage.setItem("androidAppPopupShownAt", (Date.now()).toString());
        navigate(decodeURIComponent(redirectPath || "/"));
    }
    return (
        <div className='welcome-small'>
            <div className='background-small'></div>
            <img src="/app_icon.jpg" alt="Dummy Stock Exchange game logo" className="background-img-small" />
            <div className='welcome-page-contents-small'>
                <h1 className='heading-small'>Dummy Stock Exchange</h1>
                <div className='buttons-container'>
                    <button className='btn-homepage-small' onClick={openDSEmobileApp}>Open App</button>
                    <button className='btn-homepage-small' onClick={downloadApp}>Download App</button>
                    <button className='btn-homepage-small' onClick={continueOnWeb}>Continue on Web</button>
                </div>
            </div>
        </div>
    )
}